import { __read } from "tslib";
import { useState, useEffect, useRef } from "react";
import { useReady as useTaroReady, nextTick } from "../_core/taro";
import { TaroEnv } from "./env";
/**
 * 兼容 useReady
 */
export var useReady = function (fn) {
    var callRef = useRef(false);
    if (TaroEnv) {
        // https://nervjs.github.io/taro/docs/react#%E5%AD%90%E7%BB%84%E4%BB%B6%E7%9A%84-onready
        var call_1 = function () {
            if (!callRef.current) {
                callRef.current = true;
                fn();
            }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useTaroReady(function () {
            call_1();
        });
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(function () {
            nextTick(function () {
                call_1();
            });
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
    else {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(function () {
            fn();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
    }
};
/**
 * 对 [useReady](https://nervjs.github.io/taro/docs/hooks/#useready) 的简单封装，在 ready 之前返回 false，ready 之后返回 true
 */
export function useIsReady() {
    var _a = __read(useState(false), 2), ready = _a[0], setReady = _a[1];
    useReady(function () { return setReady(true); });
    return ready;
}
//# sourceMappingURL=use-is-ready.js.map